import React, {useEffect, useRef, useState} from 'react';
import {TabPanel, TabView} from 'primereact/tabview';
import {Nullable} from '../functions/Global';
import {Splitter, SplitterPanel} from 'primereact/splitter';
import {classNames} from 'primereact/utils';
import GeoData from '../../views/GeoData';
import {setClearSelection} from "../../redux/slices/GeomonitoringSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";


type Props = {
    project: any,
    items: any,
    showMap: boolean
    activeIndex?: number,
    onTabChange?: any,
    showCard?: boolean,
    parentCallback?: any,
}

const LayoutMainContentTabMenu = (props: Props): JSX.Element => {
    const dispatch = useAppDispatch();
    const ref = useRef(null);
    const [activeIndex, setActiveIndex] = useState(props.activeIndex ? props.activeIndex : 0);
    const [height, setHeight] = useState(0);
    const [mapAvailable, setMapAvailable] = useState<boolean>(false);
    const [buttonsTop, setButtonsTop] = useState<boolean>(false);
    const clearSelectionValue = useAppSelector((state: any) => state.configLayer.layerData.clearSelection);

    useEffect(() => {
        if (ref && ref.current) {
            // @ts-ignore
            setHeight(ref.current.clientHeight);
        }
    });
    useEffect(() => {
        _setActiveIndex();
    }, []);

    useEffect(() => {
        _setActiveIndex();
    }, [window.location.hash]);

    useEffect(() => {
        _setActiveIndex();
    }, [props.items]);

    useEffect(() => {
        if (props.parentCallback) {
            props.parentCallback(activeIndex);
        }
        dispatch(setClearSelection(!clearSelectionValue))
    }, [activeIndex]);


    const _setActiveIndex = () => {
        if (window.location.hash.indexOf('_') > -1) {
            const hashElements = window.location.hash.split('_');
            if (hashElements.length > 1) {
                const index = hashElements[1];
                if (!isNaN(Number(index)) && Number(index) <= props.items.length) {
                    setActiveIndex(Number(index));
                    setMapAvailable(props.items.length > 0 && props.items[index] && props.items[index].showMap);
                    setButtonsTop(props.items.length > 0 && props.items[index] && props.items[index].buttonsTop);
                } else {
                    props.items.forEach((obj: any, i: number) => {
                        if (obj.id === index) {
                            setActiveIndex(Number(i));

                            setMapAvailable(props.items.length > 0 && props.items[i] && props.items[i].showMap);
                            setButtonsTop(props.items.length > 0 && props.items[i] && props.items[i].buttonsTop);
                        }
                    });
                }
            }
        } else {
            window.location.hash = window.location.hash + '_' + activeIndex;
        }
    };

    return (
        <div className={'relative h-full'}>
            <div className={classNames('card layout-main-content-header', buttonsTop ? 'grid grid-nogutter' : '')}
                 ref={ref}>
                <div className={'col overflow-auto'}>
                    <TabView
                        // model={props.items}
                        activeIndex={activeIndex}
                        // scrollable
                        onTabChange={(e) => {
                            setActiveIndex(e.index);
                            if (window.location.hash.indexOf('_') > -1) {
                                window.location.hash = window.location.hash.substring(0, window.location.hash.indexOf('_')) + '_' + e.index;
                            } else {
                                window.location.hash = window.location.hash + '_' + e.index;
                            }
                            if (props.onTabChange) props.onTabChange(e);
                        }}
                    >
                        {props.items.map((item: any) => {
                            if (item.visible !== false) {
                                return (<TabPanel key={item.id}
                                                  header={item.icon ?
                                                      <span style={item.disabled ? {
                                                          opacity: '0.5'
                                                      } : {}}>{item.icon}{item.label}</span> : item.label}
                                                  disabled={item.disabled}/>);
                            }
                        })}
                    </TabView>
                </div>
                <div className={'col-auto'}>
                    {props.items.length > 0 && activeIndex > -1 && props.items[activeIndex] && props.items[activeIndex].buttons}
                </div>
            </div>

            <div
                className={'scroll-card-main-content md:absolute overflow-auto' + (props.showCard === false ? '' : ' card')}
                style={{'top': (height + 13) + 'px'}}>
                <Splitter stateKey={'splitterGlobalData'}
                          stateStorage={'local'}
                          className={'w-full h-full'}
                          gutterSize={props.showMap && mapAvailable ? 4 : 0}
                          style={{border: 'none'}} onResizeEnd={() => {
                    window.dispatchEvent(new Event('resize'));
                }}>
                    <SplitterPanel
                        className={classNames('h-full relative', props.showMap && mapAvailable ? 'col-6' : 'w-full')}
                        style={{minWidth: '320px'}}>
                        {(props.items.length > 0 && activeIndex > -1) && props.items[activeIndex] && !props.items[activeIndex].disabled && props.items[activeIndex].component}
                    </SplitterPanel>
                    <SplitterPanel
                        className={props.showMap && mapAvailable ? 'relative overflow-hidden ml-2' : 'hidden'}
                        style={{borderRadius: '7px'}}>
                        {props.showMap && mapAvailable &&
                        <GeoData project={props.project} configActive={true} alarm={[]}
                                 toolkitEnabled={false}
                                 onConfigButtonClick={() => {
                                 }} onConfigClick={() => {
                        }} show={true}/>}
                    </SplitterPanel>
                </Splitter>
            </div>
        </div>
    );
};

export default LayoutMainContentTabMenu;
